import type { ConfigProviderProps } from 'antd/es/config-provider';

import { css } from 'config/emotionCss';

/* antd paints the header's border-bottom and the footer's border-top on the element's border box, so
   padding would run both edge to edge. Figma stops them at the content width, which only a margin can
   express -- hence padding-inline 0 here and the inset carried by margin instead. The && matches
   antd's own 0-2-0 selectors, which a single class would lose to on source order. */
const insetStyle = css`
  && {
    padding-inline: 0;
    margin-inline: 24px;
  }
`;

const titleStyle = css`
  overflow: hidden;
`;

const drawerConfig: ConfigProviderProps['drawer'] = {
  closeIcon: <i className="fb-icon--close" />,
  classNames: {
    header: insetStyle,
    footer: insetStyle,
    title: titleStyle,
  },
};

export default drawerConfig;
